<template>
  <slideout-panel v-on:slideout:close="closePanel" :open="createTemplatePanelIsOpen" title="Create Template">
    <div>
        <div v-if="newTemplate">
          <label for="email" class="block text-sm font-medium text-gray-700">Name</label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <PencilIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
            </div>
            <input
                @input="v$.newTemplate.name.$touch"
                v-model="newTemplate.name"
                type="text"
                name="email"
                id="email"
                class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                placeholder="Template Name" />

          </div>
          <div
              v-if="v$.newTemplate.name.$dirty"
              v-for="error in v$.newTemplate.name.$silentErrors"
              :key="error.$uid"
              class="error-msg mt-1 ml-5 text-red-500 font-bold">
            <small>
              {{ error.$message }}
            </small>
          </div>
        </div>
        <div class="mt-3">
          <primary-button :disabled="v$.$invalid" @click="handleCreateTemplate" text="Create Template" />
        </div>
    </div>
  </slideout-panel>
</template>

<script>
import SlideoutPanel from "@/components/Functional/SlideoutPanel";
import { PencilIcon } from '@heroicons/vue/solid'
import PrimaryButton from "@/components/Functional/Buttons/PrimaryButton";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators"
export default {
  name: "CreateTemplatePanel",
  components: {
    SlideoutPanel,
    PencilIcon,
    PrimaryButton,
  },
  props: ['clientId'],
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  data() {
    return {
      newTemplate: {
        name: ''
      }
    }
  },
  methods: {
    closePanel() {
      this.$store.dispatch('closeCreateTemplatePanel')
    },
    async handleCreateTemplate() {
      this.newTemplate.clientId = this.clientId
      this.$store.dispatch('showLoadingSpinner')

      try {
      await this.$store.dispatch('createTemplate', this.newTemplate)

        this.$store.dispatch('createAlert', {
          type: 'success',
          message: 'Template Successfully Created'
        })
      } catch (e) {
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e
        })
      }
      this.newTemplate.name = ''
      this.v$.newTemplate.name.$dirty = false
      this.$store.dispatch('closeCreateTemplatePanel')
      this.$store.dispatch('hideLoadingSpinner')

    }
  },
  computed: {
    createTemplatePanelIsOpen() {
      return this.$store.getters.getCreateTemplatePanelIsOpen
    }
  },
  validations: {
    newTemplate: {
      name: { required }
    }
  }
}
</script>

<style scoped>

</style>